(function () {
  // Shows the cutlery upsell whenever the cart contains at least one product
  // other than the cutlery set, and hides it once the cutlery set is in the cart.

  function checkCartForCutlery() {
    var upsellEls = document.querySelectorAll('.cutlery-upsell');
    if (!upsellEls.length) return Promise.resolve();

    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        upsellEls.forEach(function (upsellEl) {
          var cutleryVariantId = String(upsellEl.getAttribute('data-variant-id'));

          var hasCutlery = cart.items.some(function (item) {
            return String(item.variant_id) === cutleryVariantId;
          });
          var hasOtherProducts = cart.items.some(function (item) {
            return String(item.variant_id) !== cutleryVariantId;
          });

          upsellEl.style.display = (hasOtherProducts && !hasCutlery) ? 'block' : 'none';
        });
      })
      .catch(function () {});
  }

  function addCutlery(btn) {
    var wrapper = btn.closest('.cutlery-upsell');
    var variantId = wrapper.getAttribute('data-variant-id');
    var qtyInput = wrapper.querySelector('.cutlery-upsell__qty-input');
    var quantity = parseInt(qtyInput.value, 10) || 1;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        btn.textContent = 'Added!';

        // Update the cart in place via Horizon's event system rather than
        // reloading, so in-flight cart requests (e.g. the free-gift script)
        // aren't torn down.
        return import('@theme/events')
          .then(function (module) {
            return fetch('/cart.js')
              .then(function (res) { return res.json(); })
              .then(function (cart) {
                document.dispatchEvent(new module.CartUpdateEvent(cart, 'cutlery-upsell', {
                  itemCount: cart.item_count,
                  source: 'cutlery-upsell',
                  sections: {}
                }));
              });
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { itemCount: quantity, source: 'cutlery-upsell' } }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
      })
      .then(function () {
        if (qtyInput) qtyInput.value = 1;
        return checkCartForCutlery();
      })
      .catch(function () {
        btn.textContent = 'Error';
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        }, 1500);
      });
  }

  function changeQty(btn, delta) {
    var wrapper = btn.closest('.cutlery-upsell');
    var qtyInput = wrapper.querySelector('.cutlery-upsell__qty-input');
    if (!qtyInput) return;
    var current = parseInt(qtyInput.value, 10) || 1;
    var next = current + delta;
    if (next < 1) next = 1;
    qtyInput.value = next;
  }

  function init() {
    checkCartForCutlery();

    document.body.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('.cutlery-upsell__qty-minus');
      var plusBtn = e.target.closest('.cutlery-upsell__qty-plus');
      var addBtn = e.target.closest('.cutlery-upsell__add');

      if (minusBtn) changeQty(minusBtn, -1);
      if (plusBtn) changeQty(plusBtn, 1);
      if (addBtn) addCutlery(addBtn);
    });

    setInterval(checkCartForCutlery, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
